import { ChildHouseholdRate } from "./models";
/**
 * Sums monthly children household expenses
 *
 * @param children List of all childrens age and household rate
 * @param localizationParameters household standard parameters
 * @returns Sum of monthly children expenses
 */
export function sumChildrenExpenses(children, childSupportExpense, localizationParameters) {
    const childrenHouseholdExpenses = children.reduce((acc, child) => {
        if (child.age >= 0 && child.age <= localizationParameters.maxChildAge) {
            if (child.householdRate === ChildHouseholdRate.FULL_TIME) {
                return acc + localizationParameters.costOfChild.fullTime;
            }
            return acc + localizationParameters.costOfChild.halfTime;
        }
        return acc;
    }, 0);
    return childrenHouseholdExpenses + childSupportExpense;
}
/**
 * Sums monthly household living expenses
 *
 * @param input Forecast input
 * @param localizationParameters Household standard parameters
 * @returns Sum of all monthly household living expenses
 */
export function sumLivingExpenses(input, localizationParameters) {
    var _a;
    const adultsExpenses = localizationParameters.costOfAdults[input.adults.length - 1];
    const childrenExpenses = sumChildrenExpenses(input.children, input.childSupport.expense, localizationParameters);
    const carCost = (_a = input.carCost) !== null && _a !== void 0 ? _a : 0;
    return adultsExpenses + childrenExpenses + carCost;
}
